import {FC} from "react";
import {useAccount} from "@azure/msal-react";
import styles from './Avatar.module.css'

interface Props {
    seed?:string;
    big?:boolean;
    type?:string;
    inline?:boolean;
}

const Avatar: FC<Props> = (props) => {
    const acc = useAccount()

    return (
        <div className={`${styles.avatar} ${props.big ? 'h-14 w-14' : 'h-10 w-10'} ${props.inline && 'inline-block'}`}>
            <img src={`https://api.dicebear.com/8.x/${props.type || 'bottts'}/svg?seed=${props.seed || acc?.localAccountId || 'placeholder'}`} alt='Avatar'/>
        </div>
    );
};

export default Avatar;